import React, {useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import store from "../../../store";
import {saveQuote} from "../../../api/server-api";
import {userRegister} from "../../../api/user-api";
import {showQuoteSavedNotification} from "../../ui/successNotification";
import MaterialSpinner from "../../ui/materialSpinner";
import {COLORS} from "../../../colorThemes";

const LookRegisterButton = (props) => {

  const {updateInputValidations, popupClose} = props;
  const [isLoading, setIsLoading] = useState(false);

  const registerButtonClick = async () => {
    await updateInputValidations();
    const errors = store.getState().userState.userInfoErrors;
    if (Object.keys(errors).length && Object.keys(errors).some(key => errors[key] && errors[key].length)) {
      return false
    }
    setIsLoading(true);
    const registered = await userRegister();
    console.log("successfully registered", registered);
    if (!registered) {
      setIsLoading(false);
      return false
    }
    saveQuote({
      submit: true,
    })
      .then((responseData) => {
        document.kvConfig.jobId = responseData.jobId;
        showQuoteSavedNotification();
        popupClose();
        // setAssignQuotePopupSuccessText(newChangesExist ? "assignPopup.successScreenText" : "assignPopup.successScreenSaveText");
        setIsLoading(false);
      })
  }

  return (
    <Button className={"look-button look-button--primary look-button--big look-button--large ll-user__submit"}
            disabled={isLoading}
            endIcon={<ChevronRightIcon />}
            onClick={registerButtonClick}>
      <FormattedMessage id="look.register.submitButton"/>
      {isLoading ? <MaterialSpinner color={COLORS.white}/> : null}
    </Button>
  )
};

LookRegisterButton.propTypes = {
  updateInputValidations: PropTypes.func.isRequired,
  popupClose: PropTypes.func.isRequired,
}

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookRegisterButton)
